// Mock data for Dion Magee Events & Weddings

export const services = [
  {
    number: '01',
    title: 'Full Service Planning',
    subtitle: 'Complete Design & Budget Management',
    description: 'We design and plan experiences that represent you and your style and taste — since 1990. As award-winning event producers, we excel in delivering personalized, seamless experiences that are uniquely yours.',
  },
  {
    number: '02',
    title: 'Wedding Planning & Coordination',
    subtitle: 'Expert Logistics',
    description: "You can plan the experience alone — but that's no fun. Our team of experts attends to every detail, allowing you to be fully present and enjoy every single moment of your special day.",
    cta: 'View Packages & Pricing',
  },
  {
    number: '03',
    title: 'Supplier Management',
    subtitle: 'Dependable Service Providers',
    description: 'Trust us to turn your vision into reality with unmatched professionalism and passion. We maintain an exclusive network of the finest vendors, florists, caterers, and venues.',
  },
  {
    number: '04',
    title: 'On-Site Leadership',
    subtitle: 'Experienced Staff & Producer',
    description: "We've got you covered. Inspiring spaces, creative ideas, and extraordinary vendors that deliver incredible results. You are in charge of the mission — we implement it flawlessly.",
  },
];

export const portfolioItems = [
  {
    id: 27,
    title: 'Beneath the Willow\u2019s Glow',
    category: 'wedding',
    image: '/portfolio-fairytale.jpg',
    location: 'Hudson Valley, NY',
    storySlug: 'fairy-tale-wedding',
  },
  {
    id: 1,
    title: 'The Autumn Vows',
    category: 'wedding',
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80',
    location: 'Hudson Valley, NY',
  },
  {
    id: 2,
    title: 'Candlelit Garden',
    category: 'wedding',
    image: 'https://images.unsplash.com/photo-1523438885200-e635ba2c371e?w=1200&q=80',
    location: 'Provence, France',
  },
  {
    id: 25,
    title: 'Our Love Blossoms',
    category: 'wedding',
    image: '/portfolio-love-blossoms.jpg',
    location: 'Ridgefield, NJ',
    storySlug: 'our-love-blossoms',
  },
  {
    id: 3,
    title: 'Sweet Affair Soirée',
    category: 'private',
    image: 'https://images.unsplash.com/photo-1535254973040-607b474cb50d?w=1200&q=80',
    location: 'Beverly Hills, CA',
  },
  {
    id: 4,
    title: 'The Crystal Ballroom',
    category: 'corporate',
    image: 'https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?w=1200&q=80',
    location: 'Manhattan, NY',
  },
  {
    id: 5,
    title: 'Shoreline Ceremony',
    category: 'wedding',
    image: 'https://images.unsplash.com/photo-1576694667642-6f289dd54187?w=1200&q=80',
    location: 'Turks & Caicos',
  },
  {
    id: 6,
    title: 'The Alderton Affair',
    category: 'wedding',
    image: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=1200&q=80',
    location: 'Maldives',
  },
  {
    id: 7,
    title: 'Heritage Gala',
    category: 'corporate',
    image: 'https://images.unsplash.com/photo-1727425383452-2be55354f06e?w=1200&q=80',
    location: 'Charleston, SC',
  },
  {
    id: 8,
    title: 'Whispered Vows',
    category: 'private',
    image: 'https://images.unsplash.com/photo-1561848355-890d054dc55a?w=1200&q=80',
    location: 'Tuscany, Italy',
  },
  {
    id: 9,
    title: 'Eternal Bond',
    category: 'wedding',
    image: 'https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?w=1200&q=80',
    location: 'Lake Como, Italy',
  },
  {
    id: 10,
    title: 'The Glass Conservatory',
    category: 'corporate',
    image: '/portfolio-glass-conservatory.jpg',
    location: 'Charleston, SC',
  },
  {
    id: 11,
    title: 'Premiere Entertainment',
    category: 'corporate',
    image: '/portfolio-premiere-entertainment.jpg',
    location: 'Beverly Hills, CA',
  },
  {
    id: 12,
    title: 'The Coastal Retreat',
    category: 'private',
    image: '/portfolio-retreat.jpg',
    location: 'Assos, Kefalonia',
  },
  {
    id: 26,
    title: 'The Verizon Excellence Awards',
    category: 'corporate',
    image: '/vea-atrium.jpg',
    location: 'New York, NY',
    storySlug: 'the-verizon-excellence-awards',
  },
  {
    id: 13,
    title: 'The Commitment Ceremony',
    category: 'wedding',
    image: '/portfolio-commitment-ceremony.jpg',
    location: 'New York, NY',
  },
  {
    id: 14,
    title: 'The Platinum Affair',
    category: 'wedding',
    image: '/portfolio-platinum-wedding.jpg',
    location: 'Atlanta, GA',
  },
  {
    id: 15,
    title: 'The Vow Exchange',
    category: 'wedding',
    image: '/vow-first-kiss.jpg',
    location: 'Grand Prairie, TX',
    storySlug: 'the-vow-exchange',
  },
  {
    id: 16,
    title: 'Appreciation Night',
    category: 'corporate',
    image: '/portfolio-bubble-send-off.jpg',
    location: 'Dallas, Texas',
  },
  {
    id: 17,
    title: 'At The Altar',
    category: 'wedding',
    image: '/portfolio-altar-ceremony.jpg',
    location: 'Dallas, Texas',
  },
  {
    id: 18,
    title: 'The Bridal Portrait',
    category: 'wedding',
    image: '/portfolio-bridal-portrait.jpg',
    location: 'Dallas, Texas',
  },
  {
    id: 19,
    title: 'Bubbles of Love',
    category: 'wedding',
    image: '/portfolio-banquet-aerial.jpg',
    location: 'Dallas, Texas',
  },
  {
    id: 20,
    title: 'Sweet Sixteen "Tennis Shoe Ball"',
    category: 'private',
    image: '/portfolio-verizon-gala.jpg',
    location: 'New York, NY',
  },
  {
    id: 21,
    title: 'The Floral Corridor',
    category: 'corporate',
    image: '/floral-tablescape.jpg',
    location: 'San Francisco, CA',
    storySlug: 'the-floral-corridor',
  },
  {
    id: 22,
    title: 'The Foundation Gala',
    category: 'corporate',
    image: '/portfolio-foundation-gala.jpg',
    location: 'San Francisco, CA',
  },
  {
    id: 23,
    title: 'Jewish Society Appreciation Dinner (Support)',
    category: 'corporate',
    image: '/portfolio-leadership-dinner.jpg',
    location: 'New York, NY',
  },
  {
    id: 24,
    title: "King's Table",
    category: 'wedding',
    image: '/portfolio-kings-table.png',
    location: 'Springfield, NJ',
  },
  {
    id: 28,
    title: 'Fashion Explosion & Production',
    category: 'fashion',
    image: '/fashion-backstage.jpg',
    location: 'Arlington, TX',
    storySlug: 'fashion-explosion-production',
  },
];

export const processSteps = [
  {
    number: '01',
    label: 'Vision & Scope',
    title: 'The Discovery Consultation',
    description: 'Every extraordinary event begins with a conversation. We listen deeply — to your story, your vision, your guests, and your aspirations — and translate them into a singular creative brief that becomes the north star for everything that follows.',
  },
  {
    number: '02',
    label: 'Exclusive Access',
    title: 'Curatorial Venue & Vendor Selection',
    description: 'We unlock the doors that remain closed to most. Through our quarter-century of relationships with the finest venues, florists, and artisans, we curate a roster that is bespoke to your aesthetic and budget — nothing generic, nothing rushed.',
  },
  {
    number: '03',
    label: 'Aesthetic Direction',
    title: 'Bespoke Design & Atmosphere',
    description: 'Our in-house design studio translates inspiration into atmosphere. From hand-drawn floor plans to material palettes, lighting moods, and editorial-grade mood boards — every detail is composed to feel cinematic, never staged.',
  },
  {
    number: '04',
    label: 'Logistics Mastery',
    title: 'Seamless Coordination',
    description: 'Behind every effortless evening lies an exquisitely engineered production. We manage timelines, contracts, transport, accommodations, and contingencies with white-glove precision — so you remain fully present for the moments that matter.',
  },
  {
    number: '05',
    label: 'Day-Of Perfection',
    title: 'White-Glove On-Site Execution',
    description: 'On the day, our senior producer and on-site team orchestrate every cue, every entrance, every quiet pause. You arrive as a guest at your own celebration — free to feel everything, responsible for nothing.',
  },
];

export const testimonials = [
  {
    quote: 'Sir Dion and his team transformed our wedding vision into an experience that surpassed every dream. From the first consultation to the final dance, every detail was breathtaking.',
    name: 'Isabella & James Worthington',
    event: 'Estate Wedding — Hampton, NY',
  },
  {
    quote: 'A masterclass in luxury event production. The atmosphere, the choreography of moments, the impeccable taste — it felt like a film we were living inside. Truly unforgettable.',
    name: 'Alexandra & Theodore Bellamy',
    event: 'Destination Wedding — Lake Como',
  },
  {
    quote: 'We hosted 300 guests for our anniversary gala and Dion Magee Events delivered with surgical precision and an artist\'s soul. Every guest left whispering about it for months.',
    name: 'The Alderton Family',
    event: 'Private Anniversary Celebration',
  },
  {
    quote: 'I have worked with planners around the world. None compare. The discretion, the artistry, the way they hold every detail — it is genuinely a different category of service.',
    name: 'Margaux Devereaux',
    event: 'Corporate Brand Launch — Paris',
  },
];

export const stats = [
  { label: 'Award Winning', subtitle: 'Event Design Artist' },
  { number: '14', text: 'Certifications', subtitle: 'Industry Recognized' },
  { number: '25', text: 'Years', subtitle: 'Of Excellence' },
  { label: 'U.S. & Global', subtitle: 'Select International' },
];

export const heroImage = '/hero-bg.jpg';

export const heroSlides = [
  {
    image: '/hero-bg.jpg',
    objectPositionClass: 'object-[40%_55%] md:object-center',
    eyebrow: 'Destination Weddings',
    title1: 'Where Dreams',
    title2: 'Become Legend',
    caption: 'Extraordinary experiences crafted for those who demand nothing less than perfection.',
  },
  {
    image: '/hero-1.jpg',
    eyebrow: 'Romantic Soirées',
    title1: 'Lit By Whispered',
    title2: 'Candlelight',
    caption: 'Intimate moments framed in golden glow — every glance, every embrace, immortalised.',
  },
  {
    image: '/hero-2.jpg',
    eyebrow: 'Milestone Celebrations',
    title1: 'In Full Bloom',
    title2: 'Beautifully Yours',
    caption: 'Sweet sixteens, quinceañeras, and once-in-a-lifetime debuts — staged with poetic abundance.',
  },
  {
    image: '/hero-3.jpg',
    eyebrow: 'Bespoke Dinners',
    title1: 'A Table Set',
    title2: 'For Forever',
    caption: 'Crystal, candlelight, and curated silver — where every seat tells a story.',
  },
  {
    image: '/hero-4.jpg',
    eyebrow: 'Celebration Moments',
    title1: 'Generations',
    title2: 'Celebrating In Joy',
    caption: 'The smallest hands, the loudest laughter — we honor the people & leaders who make the world a better place.',
  },
  {
    image: '/hero-5.jpg',
    eyebrow: 'Wedding Experiences',
    title1: 'Our Love Blossoms',
    title2: 'It\u2019s Your Vision & Style',
    caption: 'Designing and executing your wedding celebration is our top priority.',
  },
];
export const aboutImage = '/about-couple.jpg';
